export default function RefundPolicyPage() {
  return (
    <div className="min-h-screen bg-stone-50 pt-24 pb-16" data-testid="refund-policy-page">
      <div className="max-w-3xl mx-auto px-6">
        <h1 className="text-3xl font-bold text-stone-800 mb-2">환불 정책</h1>
        <p className="text-stone-500 mb-8">최종 수정일: 2026년 5월 23일</p>

        <div className="bg-white rounded-xl border border-stone-200 p-6 space-y-6 text-sm text-stone-700 leading-relaxed">
          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">1. 유료 멤버십 (연간)</h2>
            <p>유료 멤버십(정회원·VIP)은 <strong>월 구독이 아닌 1년 단위 연간 멤버십</strong>으로 구성됩니다. 결제일로부터 1년간 서비스를 이용할 수 있으며, 만료 전 회원이 별도로 해지(캔슬)하지 않는 한 동일 조건·동일 금액으로 자동 결제·자동 연장됩니다.</p>
            <p>· 결제 후 <strong>7일 이내</strong> 서비스를 전혀 이용하지 않은 경우: <strong>전액 환불</strong></p>
            <p>· 7일 이내라도 콘텐츠 열람·매칭 추천 수령·상담 진행 등 서비스 일부 이용 시: 잔여 기간을 일할 계산하여 환불</p>
            <p>· 7일 이후: 잔여 개월 수의 30%를 환불 (위약금 70%)</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">2. 연애정보회사 매칭 플랜 (실버 / 골드 / 다이아몬드 / 로얄)</h2>
            <p>· 계약 후 매니저 배정·인터뷰 시작 전까지: <strong>90% 환불</strong></p>
            <p>· 매니저 배정 후 ~ 1회차 매칭 전: 70% 환불</p>
            <p>· 1~2회차 매칭 진행 후: 50% 환불</p>
            <p>· 3회차 이상 매칭 진행 또는 50% 기간 경과 후: 환불 불가</p>
            <p>· 회사 귀책 사유로 서비스 중단 시: <strong>전액 환불</strong></p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">3. 이벤트 · 오프라인 모임</h2>
            <p>· 이벤트 시작 <strong>7일 전</strong> 취소: 전액 환불</p>
            <p>· 3~6일 전 취소: 50% 환불</p>
            <p>· 2일 이내 취소 · 노쇼(No-show): 환불 불가</p>
            <p>· 천재지변 · 회사 사정으로 이벤트가 취소되는 경우: 전액 환불</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">4. 1:1 상담 · 줌데이트</h2>
            <p>· 상담 24시간 전까지 취소: 전액 환불</p>
            <p>· 24시간 이내 취소: 50% 환불</p>
            <p>· 상담 진행 후: 환불 불가</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">5. 환불 절차 및 처리 기간</h2>
            <p>1. 환불 요청: 마이페이지의 '환불 신청' 또는 고객센터(<a href="mailto:contact@newcoupling.com" className="text-burgundy-500 hover:underline">contact@newcoupling.com</a>)로 신청</p>
            <p>2. 회사는 영업일 기준 3~7일 이내에 결제 수단으로 환불을 진행합니다.</p>
            <p>3. 카드 결제의 경우 카드사 정책에 따라 영업일 기준 3~14일 추가 소요될 수 있습니다.</p>
            <p>4. 해외 결제·환전 수수료는 환불 금액에서 차감될 수 있습니다.</p>
          </section>

          <section>
            <h2 className="text-base font-bold text-stone-800 mb-2">6. 환불이 제한되는 경우</h2>
            <p>· 회원의 약관 위반·부정 이용으로 강제 탈퇴 처리된 경우</p>
            <p>· 타인에게 계정을 양도·대여한 사실이 확인된 경우</p>
            <p>· 무료 체험·프로모션·쿠폰으로 결제된 금액 (현금 환불 불가)</p>
          </section>

          <section className="text-xs text-stone-500 border-t border-stone-100 pt-4">
            본 환불 정책은 <strong>전자상거래 등에서의 소비자보호에 관한 법률</strong> 및 관련 법령을 준수하며, 위 정책과 법령이 충돌하는 경우 법령이 우선합니다.
          </section>
        </div>
      </div>
    </div>
  );
}
